import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';
import Promise from 'bluebird';

import {List, ListItem} from 'material-ui/List';

import Avatar from 'material-ui/Avatar';
import Business from 'material-ui/svg-icons/communication/business';
import Tethering from 'material-ui/svg-icons/device/wifi-tethering';

import {green500, blue500, orange500} from 'material-ui/styles/colors';
import * as TimeFormatter from '../utils/TimeFormatter';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import Subheader from 'material-ui/Subheader';

function pow(x, y){
  return Math.pow(x, y);
}
// Lists customers and expands users from customer when clicked, allowing
// user selection to be made.
export default @observer
class CustomerBeaconList extends Component {


  // When the user clicks customer, we will fetch the set of beacons for
  // that company and expand the beacon list as a sublist under the customer
  loadBeaconsFor(customer) {
    return function() {
      customer.loadingBeacons = true;
      AppModelUtils.fetch_beaconlist_for(customer)
      .finally(function(){
        customer.loadingBeacons = false;
      });
    }
  }

  // When a beacon has been clicked - we call the provided
  // action function with the customer/beacon id-combo:.
  beaconSelected(beacon) {
    var self = this;
    return function() {
      self.props.onSelect(beacon);
    }
  }

  formatLastUpdated(beacon) {
    if(!beacon.last_updated) return uiMsg('BP_LAST_UPDATED', 'Last updated: never');

    return uiMsg('BP_LAST_UPDATED','Last updated: <X>',
      TimeFormatter.dateAndTime(beacon.last_updated));
  }

  formatBattery(beacon) {
    if(!beacon.battery) return uiMsg('BP_UNKNOWN_BATTERY', 'Unknown battery state');
    var voltage = beacon.battery/1000;
    var percent = 100-((-11.5*pow(voltage, 3))+(282*Math.log(voltage)));
    if (percent > 100){
      percent = 100;
    }
    return Math.round(percent) + "%"; 
  }

  formatTemperature(beacon) {
    if(!beacon.temperature) return uiMsg('BP_UNKNOWN_TEMPERATURE', 'Unknown temperature');
    return beacon.temperature+"°C" 
  }

  formatRoomName(beacon) {
    if(!beacon.room_name) return uiMsg('BP_AVAILABLE', 'Available');
    return beacon.room_name 
  }

  beaconLoadingItem() {
    var element = (
      <ListItem
          key={"dummykey"}
          value={"No value"}
          leftAvatar={ <Avatar icon={<Tethering />}
                               backgroundColor={blue500} />}
          primaryText={uiMsg('BP_LOADING_BEACONS',"Loading beacons...")}
      />
    )
    return [element];
  }

  beaconItem(beacon) {
    return (
      <ListItem
        key={beacon.id}
        onTouchTap={
          this.beaconSelected(beacon).bind(this)
        }
        leftAvatar={ <Avatar icon={<Tethering />}
                             backgroundColor={blue500} />}
        primaryText={(<div><b>{beacon.id}</b>, {beacon.room_name}</div>)}
        secondaryText={this.formatBattery(beacon) + " - " + this.formatTemperature(beacon) + " - " + this.formatLastUpdated(beacon)}
        />
    )
  }

  render() {
    var self = this;
    var customers = this.props.customers;
    return (
      <List>
       {
          customers.map(function(customer) { return (
            <ListItem
                key = {customer.id}
                value={customer.id}
                leftAvatar={ <Avatar icon={<Business />}
                                    backgroundColor={orange500} />}
                primaryText={customer.name}
                initiallyOpen={true}
                nestedItems={
                  customer.loadingBeacons ? self.beaconLoadingItem() :
                  customer.beacons.map(self.beaconItem.bind(self))}
                onTouchTap={self.loadBeaconsFor(customer).bind(self)}
            />
        )})
      } </List>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/CustomerBeaconList.jsx
 **/